(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("uiv", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["uiv"] = factory(require("vue"));
	else
		root["uiv"] = factory(root["Vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_3__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition